import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';
import OHIF from '@ohif/core';
// import store from './../../store';

import setCornerstoneLayout from './utils/setCornerstoneLayout.js';
import { getEnabledElement } from './state';
import CornerstoneViewportDownloadForm from './CornerstoneViewportDownloadForm';
const scroll = cornerstoneTools.import('util/scroll');

const { studyMetadataManager } = OHIF.utils;
const { setViewportSpecificData } = OHIF.redux.actions;

const refreshCornerstoneViewports = () => {
  cornerstone.getEnabledElements().forEach(enabledElement => {
    if (enabledElement.image) {
      cornerstone.updateImage(enabledElement.element);
    }
  });
};

const commandsModule = ({ servicesManager }) => {
  const isActive = () => {
    const { viewer } = store.getState();
    if (
      viewer.activeButtonIds.length &&
      (viewer.activeButtonIds.indexOf('freehand') !== -1 ||
        viewer.activeButtonIds.indexOf('rect') !== -1)
    )
      return true;
    return false;
  };
  const actions = {
    rotateViewport: ({ viewports, rotation, type }) => {
      if (isActive()) {
        if (type === 'mark') {
          const enabledElement = getEnabledElement(
            viewports.activeViewportIndex
          );

          if (enabledElement) {
            let viewport = cornerstone.getViewport(enabledElement);
            viewport.rotation += rotation;
            cornerstone.setViewport(enabledElement, viewport);
          }
        }
      } else {
        if (type === 'mark') return;
        const enabledElement = getEnabledElement(viewports.activeViewportIndex);

        if (enabledElement) {
          let viewport = cornerstone.getViewport(enabledElement);
          viewport.rotation += rotation;
          cornerstone.setViewport(enabledElement, viewport);
        }
      }
    },
    flipViewportHorizontal: ({ viewports, type }) => {
      if (isActive()) {
        if (type === 'mark') {
          const enabledElement = getEnabledElement(
            viewports.activeViewportIndex
          );

          if (enabledElement) {
            let viewport = cornerstone.getViewport(enabledElement);
            viewport.hflip = !viewport.hflip;
            cornerstone.setViewport(enabledElement, viewport);
          }
        }
      } else {
        if (type === 'mark') return;
        const enabledElement = getEnabledElement(viewports.activeViewportIndex);

        if (enabledElement) {
          let viewport = cornerstone.getViewport(enabledElement);
          viewport.hflip = !viewport.hflip;
          cornerstone.setViewport(enabledElement, viewport);
        }
      }
    },
    flipViewportVertical: ({ viewports, type }) => {
      if (isActive()) {
        if (type === 'mark') {
          const enabledElement = getEnabledElement(
            viewports.activeViewportIndex
          );

          if (enabledElement) {
            let viewport = cornerstone.getViewport(enabledElement);
            viewport.vflip = !viewport.vflip;
            cornerstone.setViewport(enabledElement, viewport);
          }
        }
      } else {
        if (type === 'mark') return;
        const enabledElement = getEnabledElement(viewports.activeViewportIndex);

        if (enabledElement) {
          let viewport = cornerstone.getViewport(enabledElement);
          viewport.vflip = !viewport.vflip;
          cornerstone.setViewport(enabledElement, viewport);
        }
      }
    },
    scaleViewport: ({ direction, viewports, type }) => {
      if (isActive()) {
        if (type === 'mark') {
          const enabledElement = getEnabledElement(
            viewports.activeViewportIndex
          );
          const step = direction * 0.15;

          if (enabledElement) {
            if (step) {
              let viewport = cornerstone.getViewport(enabledElement);
              viewport.scale += step;
              cornerstone.setViewport(enabledElement, viewport);
            } else {
              cornerstone.fitToWindow(enabledElement);
            }
          }
        }
      } else {
        if (type === 'mark') return;
        const enabledElement = getEnabledElement(viewports.activeViewportIndex);
        const step = direction * 0.15;

        if (enabledElement) {
          if (step) {
            let viewport = cornerstone.getViewport(enabledElement);
            viewport.scale += step;
            cornerstone.setViewport(enabledElement, viewport);
          } else {
            cornerstone.fitToWindow(enabledElement);
          }
        }
      }
    },
    resetViewport: ({ viewports, type }) => {
      if (isActive()) {
        if (type === 'mark') {
          const enabledElement = getEnabledElement(
            viewports.activeViewportIndex
          );

          if (enabledElement) {
            cornerstone.reset(enabledElement);
          }
        }
      } else {
        if (type === 'mark') return;
        const enabledElement = getEnabledElement(viewports.activeViewportIndex);

        if (enabledElement) {
          cornerstone.reset(enabledElement);
        }
      }
    },
    boneViewport: ({ viewports }) => {
      // const state = store.getState();
      // const { preferences = {} } = state;
      // const { window, level } =
      //   preferences.windowLevelData && preferences.windowLevelData[preset];

      // if (window && level) {
      //   commandsManager.runCommand('setWindowLevel', {
      //     viewports,
      //     window,
      //     level,
      //   });
      // }
      const enabledElement = getEnabledElement(viewports.activeViewportIndex);

      if (enabledElement) {
        let viewport = cornerstone.getViewport(enabledElement);

        viewport.voi = {
          windowWidth: 1500,
          windowCenter: 300,
        };
        cornerstone.setViewport(enabledElement, viewport);
      }
    },
    lungViewport: ({ viewports }) => {
      const enabledElement = getEnabledElement(viewports.activeViewportIndex);

      if (enabledElement) {
        let viewport = cornerstone.getViewport(enabledElement);

        viewport.voi = {
          windowWidth: 1500,
          windowCenter: -600,
        };
        cornerstone.setViewport(enabledElement, viewport);
      }
    },
    mediastinumViewport: ({ viewports }) => {
      const enabledElement = getEnabledElement(viewports.activeViewportIndex);

      if (enabledElement) {
        let viewport = cornerstone.getViewport(enabledElement);

        viewport.voi = {
          windowWidth: 350,
          windowCenter: 40,
        };
        cornerstone.setViewport(enabledElement, viewport);
      }
    },
    invertViewport: ({ viewports, type }) => {
      if (isActive()) {
        if (type === 'mark') {
          const enabledElement = getEnabledElement(
            viewports.activeViewportIndex
          );

          if (enabledElement) {
            let viewport = cornerstone.getViewport(enabledElement);
            viewport.invert = !viewport.invert;
            cornerstone.setViewport(enabledElement, viewport);
          }
        }
      } else {
        if (type === 'mark') return;
        const enabledElement = getEnabledElement(viewports.activeViewportIndex);

        if (enabledElement) {
          let viewport = cornerstone.getViewport(enabledElement);
          viewport.invert = !viewport.invert;
          cornerstone.setViewport(enabledElement, viewport);
        }
      }
    },
    // TODO: this is receiving `evt` from `ToolbarRow`. We could use it to have
    //       better mouseButtonMask sets.
    setToolActive: ({ toolName }) => {
      if (!toolName) {
        console.warn('No toolname provided to setToolActive command');
      }
      cornerstoneTools.setToolActive(toolName, { mouseButtonMask: 1 });
    },
    clearAnnotations: ({ viewports }) => {
      const element = getEnabledElement(viewports.activeViewportIndex);
      if (!element) {
        return;
      }

      const enabledElement = cornerstone.getEnabledElement(element);
      if (!enabledElement || !enabledElement.image) {
        return;
      }

      const {
        toolState,
      } = cornerstoneTools.globalImageIdSpecificToolStateManager;
      if (
        !toolState ||
        toolState.hasOwnProperty(enabledElement.image.imageId) === false
      ) {
        return;
      }

      const imageIdToolState = toolState[enabledElement.image.imageId];

      const measurementsToRemove = [];

      Object.keys(imageIdToolState).forEach(toolType => {
        const { data } = imageIdToolState[toolType];

        data.forEach(measurementData => {
          const {
            _id,
            lesionNamingNumber,
            measurementNumber,
          } = measurementData;
          if (!_id) {
            return;
          }

          measurementsToRemove.push({
            toolType,
            _id,
            lesionNamingNumber,
            measurementNumber,
          });
        });
      });

      measurementsToRemove.forEach(measurementData => {
        OHIF.measurements.MeasurementHandlers.onRemoved({
          detail: {
            toolType: measurementData.toolType,
            measurementData,
          },
        });
      });
    },
    nextImage: ({ viewports, type }) => {
      // 标注状态
      if (isActive()) {
        if (type == 'mark') {
          const enabledElement = getEnabledElement(
            viewports.activeViewportIndex
          );
          scroll(enabledElement, 1);
        }
      } else {
        if (type == 'mark') return;
        const enabledElement = getEnabledElement(viewports.activeViewportIndex);
        scroll(enabledElement, 1);
      }
    },

    previousImage: ({ viewports, type }) => {
      if (isActive()) {
        if (type == 'mark') {
          const enabledElement = getEnabledElement(
            viewports.activeViewportIndex
          );
          scroll(enabledElement, -1);
        }
      } else {
        if (type == 'mark') return;
        const enabledElement = getEnabledElement(viewports.activeViewportIndex);
        scroll(enabledElement, -1);
      }
    },

    getActiveViewportEnabledElement: ({ viewports }) => {
      const enabledElement = getEnabledElement(viewports.activeViewportIndex);
      return enabledElement;
    },
    showDownloadViewportModal: ({ title, viewports }) => {
      const activeViewportIndex = viewports.activeViewportIndex;
      const { UIModalService } = servicesManager.services;
      if (UIModalService) {
        UIModalService.show({
          content: CornerstoneViewportDownloadForm,
          title,
          contentProps: {
            activeViewportIndex,
            onClose: UIModalService.hide,
          },
        });
      }
    },
    updateTableWithNewMeasurementData({
      toolType,
      measurementNumber,
      location,
      description,
    }) {
      // Update all measurements by measurement number
      // if (isActive()) return;
      const measurementApi = OHIF.measurements.MeasurementApi.Instance;
      const measurements = measurementApi.tools[toolType].filter(
        m => m.measurementNumber === measurementNumber
      );

      measurements.forEach(measurement => {
        measurement.location = location;
        measurement.description = description;

        measurementApi.updateMeasurement(measurement.toolType, measurement);
      });

      measurementApi.syncMeasurementsAndToolData();

      refreshCornerstoneViewports();
    },
    getNearbyToolData({ element, canvasCoordinates, availableToolTypes }) {
      const nearbyTool = {};
      let pointNearTool = false;

      availableToolTypes.forEach(toolType => {
        const elementToolData = cornerstoneTools.getToolState(
          element,
          toolType
        );

        if (!elementToolData) {
          return;
        }

        elementToolData.data.forEach((toolData, index) => {
          let elementToolInstance = cornerstoneTools.getToolForElement(
            element,
            toolType
          );

          if (!elementToolInstance) {
            elementToolInstance = cornerstoneTools.getToolForElement(
              element,
              `${toolType}Tool`
            );
          }

          if (!elementToolInstance) {
            console.warn('Tool not found.');
            return undefined;
          }

          if (
            elementToolInstance.pointNearTool(
              element,
              toolData,
              canvasCoordinates
            )
          ) {
            pointNearTool = true;
            nearbyTool.tool = toolData;
            nearbyTool.index = index;
            nearbyTool.toolType = toolType;
          }
        });

        if (pointNearTool) {
          return false;
        }
      });

      return pointNearTool ? nearbyTool : undefined;
    },
    removeToolState: ({ element, toolType, tool }) => {
      cornerstoneTools.removeToolState(element, toolType, tool);
      cornerstone.updateImage(element);
    },
    setCornerstoneLayout: () => {
      setCornerstoneLayout();
    },
    setWindowLevel: ({ viewports, window, level }) => {
      const enabledElement = getEnabledElement(viewports.activeViewportIndex);

      if (enabledElement) {
        let viewport = cornerstone.getViewport(enabledElement);

        viewport.voi = {
          windowWidth: Number(window),
          windowCenter: Number(level),
        };
        cornerstone.setViewport(enabledElement, viewport);
      }
    },
    jumpToImage: ({
      StudyInstanceUID,
      SOPInstanceUID,
      frameIndex,
      activeViewportIndex,
      refreshViewports = true,
    }) => {
      const study = studyMetadataManager.get(StudyInstanceUID);

      const displaySet = study.findDisplaySet(ds => {
        return (
          ds.images &&
          ds.images.find(i => i.getSOPInstanceUID() === SOPInstanceUID)
        );
      });

      if (!displaySet) {
        return;
      }

      displaySet.SOPInstanceUID = SOPInstanceUID;
      displaySet.frameIndex = frameIndex;

      window.store.dispatch(
        setViewportSpecificData(activeViewportIndex, displaySet)
      );
      let item = displaySet.images[frameIndex];
      let tool = {};
      // const element = document.querySelector('.viewport-element');
      // if (item.isMark) {//有标注
      //   if (item.isSelect) { //且已勾选的
      //     if (item.isCanvs) { //已绘制
      //       console.log('不处理');
      //     } else { //未绘制
      //       tool = {
      //         "visible": true,
      //         "active": true,
      //         "invalidated": false,
      //         "isMeasurements": true,
      //         "handles": {
      //           "start": {
      //             "x": item.range_x[0],
      //             "y": item.range_x[1],
      //             "highlight": true,
      //             "active": false
      //           },
      //           "end": {
      //             "x": item.range_y[0],
      //             "y": item.range_y[1],
      //             "highlight": true,
      //             "active": false,
      //             "moving": false
      //           },
      //           "initialRotation": 0,
      //           "textBox": {
      //             "active": false,
      //             "hasMoved": false,
      //             "movesIndependently": false,
      //             "drawnIndependently": true,
      //             "allowedOutsideImage": true,
      //             "hasBoundingBox": true,
      //             "x": 277.40,
      //             "y": 193.88457008244993,
      //             "boundingBox": {
      //               "width": 280.53,
      //               "height": 45,
      //               "left": 601,
      //               "top": 299
      //             }
      //           }
      //         },
      //         "uuid": displaySet.uid,
      //         "PatientID": "p2106010014",
      //         "StudyInstanceUID": displaySet.StudyInstanceUID,
      //         "SeriesInstanceUID": displaySet.SeriesInstanceUID,
      //         "SOPInstanceUID": displaySet.images[frameIndex].SOPInstanceUID,
      //         "frameIndex": 0,
      //         "imagePath": "1.3.6.1.4.1.46677.0.900020.2106010014.2106010014_1.3.12.2.1107.5.1.7.107092.30000021060109552308700000140_1.3.12.2.1107.5.1.7.107092.30000021060109552308700000152_0",
      //         "lesionNamingNumber": 2,
      //         "userId": null,
      //         "toolType": "RectangleRoi",
      //         "_id": "0fabdf6a-20bd-f47a-16fc-ee41c6f66f8f",
      //         "timepointId": "TimepointId",
      //         "measurementNumber": 1,
      //         "cachedStats": {
      //           "area": 49,
      //           "count": 131,
      //           "mean": 48,
      //           "variance": 181,
      //           "stdDev": 134,
      //           "min": -1086,
      //           "max": 933
      //         },
      //         "unit": "HU"
      //       };
      //       cornerstoneTools.addToolState(element, 'RectangleRoi', tool);
      //       cornerstone.updateImage(element);
      //       displaySet.images[frameIndex].isCanvs = true;
      //     }
      //   } else { //未勾选
      //     if (item.isCanvs) { //已绘制
      //       cornerstoneTools.clearToolState(element, 'RectangleRoi');
      //       cornerstone.updateImage(element);
      //     } else { //未绘制
      //       console.log('不处理');
      //     }
      //   }
      // }

      if (refreshViewports) {
        refreshCornerstoneViewports();
      }
    },
  };

  const definitions = {
    jumpToImage: {
      commandFn: actions.jumpToImage,
      storeContexts: [],
      options: {},
      type: '',
    },
    getNearbyToolData: {
      commandFn: actions.getNearbyToolData,
      storeContexts: [],
      options: {},
      type: '',
    },
    removeToolState: {
      commandFn: actions.removeToolState,
      storeContexts: [],
      options: {},
      type: '',
    },
    updateTableWithNewMeasurementData: {
      commandFn: actions.updateTableWithNewMeasurementData,
      storeContexts: [],
      options: {},
      type: '',
    },
    showDownloadViewportModal: {
      commandFn: actions.showDownloadViewportModal,
      storeContexts: ['viewports'],
      options: {},
      type: '',
    },
    getActiveViewportEnabledElement: {
      commandFn: actions.getActiveViewportEnabledElement,
      storeContexts: ['viewports'],
      options: {},
      type: '',
    },
    rotateViewportCW: {
      commandFn: actions.rotateViewport,
      storeContexts: ['viewports'],
      options: { rotation: 180 },
      type: '',
    },
    rotateViewportCCW: {
      commandFn: actions.rotateViewport,
      storeContexts: ['viewports'],
      options: { rotation: -90 },
      type: '',
    },
    invertViewport: {
      commandFn: actions.invertViewport,
      storeContexts: ['viewports'],
      options: {},
      type: '',
    },
    flipViewportVertical: {
      commandFn: actions.flipViewportVertical,
      storeContexts: ['viewports'],
      options: {},
      type: '',
    },
    flipViewportHorizontal: {
      commandFn: actions.flipViewportHorizontal,
      storeContexts: ['viewports'],
      options: {},
      type: '',
    },
    scaleUpViewport: {
      commandFn: actions.scaleViewport,
      storeContexts: ['viewports'],
      options: { direction: 1 },
      // type: 'routine',
    },
    scaleDownViewport: {
      commandFn: actions.scaleViewport,
      storeContexts: ['viewports'],
      options: { direction: -1 },
      // type: 'routine',
    },
    fitViewportToWindow: {
      commandFn: actions.scaleViewport,
      storeContexts: ['viewports'],
      options: { direction: 0 },
      type: '',
    },
    resetViewport: {
      commandFn: actions.resetViewport,
      storeContexts: ['viewports'],
      options: {},
      type: '',
    },
    boneViewport: {
      commandFn: actions.boneViewport,
      storeContexts: ['viewports'],
      options: {},
      type: '',
    },
    lungViewport: {
      commandFn: actions.lungViewport,
      storeContexts: ['viewports'],
      options: {},
      type: '',
    },
    mediastinumViewport: {
      commandFn: actions.mediastinumViewport,
      storeContexts: ['viewports'],
      options: {},
      type: '',
    },
    clearAnnotations: {
      commandFn: actions.clearAnnotations,
      storeContexts: ['viewports'],
      options: {},
      type: '',
    },
    nextImage: {
      commandFn: actions.nextImage,
      storeContexts: ['viewports'],
      options: {},
      // type: 'routine',
    },
    previousImage: {
      commandFn: actions.previousImage,
      storeContexts: ['viewports'],
      options: {},
      // type: 'routine',
    },
    // TOOLS
    setToolActive: {
      commandFn: actions.setToolActive,
      storeContexts: [],
      options: {},
      type: '',
    },
    setZoomTool: {
      commandFn: actions.setToolActive,
      storeContexts: [],
      options: { toolName: 'Zoom' },
      type: '',
    },
    setCornerstoneLayout: {
      commandFn: actions.setCornerstoneLayout,
      storeContexts: [],
      options: {},
      context: 'VIEWER',
      type: '',
    },
    setWindowLevel: {
      commandFn: actions.setWindowLevel,
      storeContexts: ['viewports'],
      options: {},
      type: '',
    },

    /*********lhwen add ******************** */
    markNextImage: {
      commandFn: actions.nextImage,
      storeContexts: ['viewports'],
      options: { type: 'mark' },
      type: 'mark',
    },
    markPreviousImage: {
      commandFn: actions.previousImage,
      storeContexts: ['viewports'],
      options: { type: 'mark' },
      // type: 'mark',
    },
    markScaleUpViewport: {
      commandFn: actions.scaleViewport,
      storeContexts: ['viewports'],
      options: { direction: 1, type: 'mark' },
      // type: 'mark',
    },
    markScaleDownViewport: {
      commandFn: actions.scaleViewport,
      storeContexts: ['viewports'],
      options: { direction: -1, type: 'mark' },
      // type: 'mark',
    },
    /*************************************** */
  };

  return {
    actions,
    definitions,
    defaultContext: 'ACTIVE_VIEWPORT::CORNERSTONE',
  };
};

export default commandsModule;
